<template>
    <div>
      <v-breadcrumbs
        large
        :items="crumbs"
        divider="/"
        class="pl-0"
      ></v-breadcrumbs>

      <h1 class="primary--text">
        <v-icon color="primary">mdi-account-multiple</v-icon> <span>Gestão de Subscrições</span>
      </h1>
        <div style="position:relative">
        <v-container>
          <v-speed-dial
            absolute
            v-model="speedDial"
            top
            right
            direction="bottom"
            :open-on-hover="true"
          >
            <template v-slot:activator>
              <v-tooltip right color="primary">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs" v-on="on"
                    v-model="speedDial"
                    color="primary"
                    dark
                    x-large
                    fab
                  >
                    <v-icon v-if="speedDial">
                      mdi-close
                    </v-icon>
                    <v-icon v-else>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>
                <span>Opções</span>
              </v-tooltip>
            </template>
            <v-tooltip right color="info">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs" v-on="on"
                  fab
                  dark
                  small
                  color="info"
                  large
                  @click="searching = true"
                >
                  <v-icon>mdi-filter</v-icon>
                </v-btn>
              </template>
              <span>Pesquisar</span>
            </v-tooltip>
            <v-tooltip right color="secondary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs" v-on="on"
                  fab
                  dark
                  small
                  color="secondary"
                  large
                  to="/subscriptions_types/create"
                  v-if="$root.session.hasPermission(['super', 'subscriptions.create'])"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Registar</span>
            </v-tooltip>
          </v-speed-dial>
        </v-container>

        <v-data-table
          :headers="headers"
          :items="items"
          :server-items-length="total"
          :loading="loading"
          :footer-props="tableFooter"
          :options.sync="options"
          class="mt-16 elevation-10"
          locale="pt-pt"
        >
         

          <template v-slot:item.actions="{item}">
            <IconView
              class="mr-2"
              @click="viewSubscription(item)"
            />
            <IconRemove
              v-if="$root.session.hasPermission(['super', 'subscriptions.delete'])"
              class="mr-2"
              @on-submit="deleteSubscription(item)"
            />
          </template>
        </v-data-table>
      </div>
      <v-navigation-drawer
          fixed
          right
          v-model="searching"
          hide-overlay
          width="520"
          class="pt-6"
        >
        <v-list>
          <v-list-item>
            <v-btn fab small color="secondary" @click="searching = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-btn absolute right small color="error" @click="resetSubscription">
              Limpar Campos
            </v-btn>
          </v-list-item>
        </v-list>
        <v-list class="pt-10">
          <v-form @submit.prevent="searchSubscription">
            
            <v-list-item>
              <v-text-field
                v-model="filter.name"
                prepend-inner-icon="mdi-account-details"
                label="Código"
                clearable
              ></v-text-field>
            </v-list-item>

            <v-list-item>
              <v-text-field
                v-model="filter.display_name"
                prepend-inner-icon="mdi-account-details"
                label="Nome"
                clearable
              ></v-text-field>
            </v-list-item>

            <v-list-item>
              <v-checkbox
                v-model="filter.deleted"
                prepend-inner-icon="mdi-deleted"
                label="Eliminados"
                clearable
              ></v-checkbox>
            </v-list-item>
            <v-row
              class="mt-10"
              align="center"
              justify="space-around"
            >
            <v-btn
              color="primary"
              type="submit"
            >
              Pesquisar
            </v-btn>
            </v-row>
          </v-form>
        </v-list>
      </v-navigation-drawer>
    </div>
</template>
<script>
import IconRemove from '@/components/ui/IconRemove.vue';
import IconView from '@/components/ui/IconView.vue';
import Subscription from "@/api/SubscriptionTypes.js";

export default {
  components: {
    IconRemove,
    IconView
  },
  watch: {
    'options': {
      immediate: false,
      handler () {
        setTimeout(() => {this.searchSubscription()}, 10);
      },
      deep: true,
    },
  },
  beforeCreate(){
    document.title = "Hefesto - Gestão de Subscrições";

  },
  data: () => ({
    headers: [
      {
        text: 'Subscrição',
        sortable: false,
        value: 'type',
      },
      {
        text: 'Preço (€)',
        sortable: false,
        value: 'price',
      },
      {
        text: 'Dias',
        sortable: false,
        value: 'days',
      },
      { 
        text: 'Opções', 
        value: 'actions', 
        sortable: false 
      },
    ],
    items: [],
    total: 0,
    loading: false,
    searching: false,
    tableFooter: {
      'items-per-page-options': [5, 10, 15, 20],
      'items-per-page-text': "Linhas por página"
    },
    options: {},
    speedDial:false,
    filter: {
      name: null,
      display_name:null,
      user_id:null,
      deleted: false
    },
    users:[]
  }),
  mounted(){

    if(!this.$root.session.hasPermission(["super", "subscriptions.read"])) {
      this.$router.push('/admin');
    }

    this.fillBaseData();
  },
  methods:{
    fillBaseData() {

      if(localStorage["subscriptions-global-" + this.$root.session.id] != undefined){

        let data = JSON.parse(localStorage["subscriptions-global-" + this.$root.session.id]);

        this.filter = data.filter;

        this.options = data.options;
      }
    },
    searchSubscription(event){
      if(!!event && event.type == 'submit'){
        this.options.page = 1;
      }

      this.loading = true;

      let filter = {...this.filter};

      let request = {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        deleted: this.filter.deleted
      };
    
      Object.assign(request, filter);

      localStorage["subscriptions-global-" + this.$root.session.id] = JSON.stringify({
        filter: this.filter,
        options: this.options,
      });

      Subscription.search(request).then(response => {
        
        let data = response.data;

        this.total = data.total;

        this.items = data.data.map((item) => {

          this.searching = false;

          return item;
        });

        this.loading = false;

      });
    },
    resetSubscription()
    {
      this.filter = {};

      this.searchSubscription();
    },
    viewSubscription(item){
      this.$router.push('subscriptions_types/update/' + item.id);
    },
    deleteSubscription(item){
      Subscription.delete(item.id)
        .then(() => {
          this.searchSubscription();
        });
    },
  },
  computed: {
    crumbs: function() {
      return [
        {
          text: 'Gestão de subscrições',
          disabled: false,
          to: '/subscriptions',
          exact: true,
        },
      ];
    }
  }
};
</script>
